function starhomeDimensionValue(value, rule) {
  const cleaned = String(value).trim();
  if (!/^\d+$/.test(cleaned)) return null;
  const number = Number(cleaned);
  return number >= rule.min && number <= rule.max ? `${number} mm` : null;
}
function starhomeCanopyWidthRange(options, values) {
  for (let i = 0; i < options.length; i++) {
    if (!/maß|breite/i.test(options[i])) continue;
    const value = String(values[i] || '');
    const match = value.match(/^\s*(\d+(?:[.,]\d+)?)\s*[-–—]\s*(\d+(?:[.,]\d+)?)(?=\s*(?:[x×]|mm\b|cm\b|$))/i);
    if (!match) continue;
    const factor = /\bmm\b/i.test(value) ? 1 : 10;
    const min = Math.round(Number(match[1].replace(',', '.')) * factor);
    const max = Math.round(Number(match[2].replace(',', '.')) * factor);
    if (min > 0 && max > min) return { min, max };
  }
  return null;
}
function starhomeCanopyWidthValid(value, range) {
  return !!range && /^\d+$/.test(String(value).trim()) && Number(value) >= range.min && Number(value) <= range.max;
}
if (typeof window !== 'undefined') {
  window.starhomeCanopyWidthValues ||= new Map();
  window.StarhomeCanopyWidth = { range: starhomeCanopyWidthRange, valid: starhomeCanopyWidthValid };
  if (!customElements.get('starhome-vordach-width')) {
    customElements.define('starhome-vordach-width', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.form = this.closest('form');
        this.input = this.querySelector('[data-width-input]');
        this.property = this.querySelector('[data-width-property]');
        this.fields = this.querySelector('[data-width-fields]');
        this.help = this.querySelector('[data-width-help]');
        this.error = this.querySelector('[data-width-error]');
        this.configuration = JSON.parse(this.querySelector('[data-custom-configuration]')?.textContent || '{}');
        if (this.configuration.dimensions) { this.connectDimensions(signal); return; }
        this.catalog = JSON.parse(this.querySelector('[data-width-variants]').textContent);
        this.catalog.variants = this.catalog.ids.map((id,i)=>({id,options:[this.catalog.option1?.[i]||'',this.catalog.option2?.[i]||'',this.catalog.option3?.[i]||'']}));
        this.prefill = window.starhomeCanopyWidthValues.has(this.dataset.productId) ? window.starhomeCanopyWidthValues.get(this.dataset.productId) : new URL(window.location.href).searchParams.get('vordach_breite_mm');
        this.addEventListener('input', event => {
          if (event.target.matches('[data-extra-input]')) { this.validate(false); return; }
          if (!event.target.matches('[data-width-input]')) return;
          this.input = event.target;
          window.starhomeCanopyWidthValues.set(this.dataset.productId, this.input.value);
          this.validate(false);
        }, { signal });
        this.form.addEventListener('formdata', event => {
          this.sync();
          if (this.range && this.validate(false)) event.formData.set('properties[Individuelle Dachbreite]', `${this.input.value} mm`);
          else event.formData.delete('properties[Individuelle Dachbreite]');
        }, { signal });
        document.addEventListener('variant:update', () => queueMicrotask(() => this.sync()), { signal });
        this.form.addEventListener('change', () => queueMicrotask(() => this.sync()), { signal });
        this.observer = new MutationObserver(() => this.sync());
        const variantId = this.form.querySelector('[name="id"]');
        if (variantId) this.observer.observe(variantId, { attributes: true, attributeFilter: ['value'] });
        this.sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
      }
      connectDimensions(signal) {
        window.starhomeDimensionValues ||= new Map();
        for (const input of this.querySelectorAll('[data-dimension-field]')) {
          const key = `${this.dataset.productId}:${input.dataset.dimensionField}`;
          input.value = window.starhomeDimensionValues.get(key) || '';
          input.addEventListener('input', () => { window.starhomeDimensionValues.set(key, input.value); this.validateDimensions(false); }, {signal});
        }
        this.form.addEventListener('formdata', event => {
          if (!this.validateDimensions(false)) return;
          for (const input of this.querySelectorAll('[data-dimension-field]')) {
            const rule = this.configuration.dimensions[input.dataset.dimensionField];
            event.formData.set(input.name, rule ? starhomeDimensionValue(input.value,rule) : input.value.trim());
          }
        }, {signal});
        this.validateDimensions(false);
      }
      validateDimensions(report) {
        let valid = true;
        for (const input of this.querySelectorAll('[data-dimension-field]')) {
          const rule = this.configuration.dimensions[input.dataset.dimensionField];
          const ok = rule ? !!starhomeDimensionValue(input.value,rule) : !!input.value.trim() && input.value.trim().length <= 120;
          const message = ok ? '' : rule ? `Bitte geben Sie eine ganze Zahl zwischen ${rule.min} und ${rule.max} mm ein.` : 'Bitte geben Sie die gewünschte Farbkennung ein.';
          input.setCustomValidity(message);
          input.setAttribute('aria-invalid', String(!ok));
          if (!ok && valid && report) { input.focus(); input.reportValidity(); }
          valid = valid && ok;
        }
        return valid;
      }
      sync() {
        if (this.configuration?.dimensions) { this.validateDimensions(false); return; }
        this.input = this.querySelector('[data-width-input]');
        this.property = this.querySelector('[data-width-property]');
        this.fields = this.querySelector('[data-width-fields]');
        this.help = this.querySelector('[data-width-help]');
        this.error = this.querySelector('[data-width-error]');
        const id = this.form.querySelector('[name="id"]')?.value;
        const variant = this.catalog.variants.find(variant => String(variant.id) === String(id));
        this.range = variant ? starhomeCanopyWidthRange(this.catalog.options, variant.options) : null;
        this.fields.hidden = !this.range;
        this.input.required = !!this.range;
        this.input.disabled = !this.range;
        this.property.disabled = !this.range;
        if (this.range) {
          this.input.min = this.range.min;
          this.input.max = this.range.max;
          this.help.textContent = `Zulässige Dachbreite: ${this.range.min}–${this.range.max} mm. 10 mm entsprechen 1 cm.`;
          if (this.prefill !== null) {
            this.input.value = this.prefill;
            window.starhomeCanopyWidthValues.set(this.dataset.productId, this.prefill);
            this.prefill = null;
          } else if (window.starhomeCanopyWidthValues.has(this.dataset.productId)) {
            this.input.value = window.starhomeCanopyWidthValues.get(this.dataset.productId);
          }
        } else {
          this.property.value = '';
          this.input.setCustomValidity('');
          this.error.hidden = true;
          this.input.removeAttribute('aria-invalid');
        }
        for (const kind of ['height', 'colour']) {
          const input = this.querySelector(`[data-extra-input="${kind}"]`);
          if (!input) continue;
          const active = kind === 'height' ? !!this.range && !!this.configuration.sideHeight : !!this.configuration.colour && (this.configuration.colourAlways || !!variant?.options.some(value => /sonderfarbe/i.test(value)));
          this.querySelector(`[data-extra-fields="${kind}"]`).hidden = !active;
          input.disabled = !active;
          input.required = active;
          const property = this.querySelector(`[data-extra-property="${kind}"]`);
          property.disabled = !active;
          if (!active) { property.value = ''; input.setCustomValidity(''); }
          if (kind === 'height' && active) { input.min = this.configuration.sideHeight.min; input.max = this.configuration.sideHeight.max; }
        }
        this.validate(false);
      }
      validateExtras(report) {
        let valid = true;
        for (const kind of ['height', 'colour']) {
          const input = this.querySelector(`[data-extra-input="${kind}"]`);
          if (!input || input.disabled) continue;
          const value = input.value.trim();
          const ok = kind === 'height' ? starhomeCanopyWidthValid(value, this.configuration.sideHeight) : value.length > 0 && value.length <= 120;
          input.setCustomValidity(ok ? '' : kind === 'height' ? `Bitte geben Sie die Seitenteilhöhe zwischen ${input.min} und ${input.max} mm ein.` : 'Bitte geben Sie Ihre gewünschte Farbkennung ein.');
          this.querySelector(`[data-extra-property="${kind}"]`).value = ok ? value + (kind === 'height' ? ' mm' : '') : '';
          if (!ok && valid && report) { input.focus(); input.reportValidity(); }
          valid = valid && ok;
        }
        return valid;
      }
      validate(report) {
        if (this.configuration?.dimensions) return this.validateDimensions(report);
        const extrasValid = this.validateExtras(report);
        if (!this.range) return extrasValid;
        const valid = starhomeCanopyWidthValid(this.input.value, this.range);
        const message = valid ? '' : `Bitte geben Sie die gewünschte Dachbreite als ganze Zahl zwischen ${this.range.min} und ${this.range.max} mm ein.`;
        this.input.setCustomValidity(message);
        this.input.setAttribute('aria-invalid', String(!valid));
        this.error.textContent = message;
        this.error.hidden = valid || (!report && this.input.value === '');
        this.property.value = valid ? `${Number(this.input.value)} mm` : '';
        if (report && !valid) { this.error.hidden = false; this.input.focus(); this.input.reportValidity(); }
        return valid && extrasValid;
      }
    });
  }
  if (!window.starhomeCanopyWidthSubmitGuard) {
    window.starhomeCanopyWidthSubmitGuard = true;
    document.addEventListener('submit', event => {
      const controls = event.target.querySelectorAll('starhome-vordach-width');
      for (const control of controls) {
        control.sync();
        if (!control.validate(true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
      }
    }, true);
  }
}


if (typeof window !== 'undefined' && !customElements.get('starhome-canopy-merge-preview')) {
  window.starhomeMergePreviewValues ||= new Map();
  customElements.define('starhome-canopy-merge-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.catalog = JSON.parse(this.querySelector('[data-merge-catalog]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-merge-strings]').textContent);
      this.selects = [...this.querySelectorAll('[data-merge-option]')];
      this.inputs = [...this.querySelectorAll('[data-merge-input]')];
      const saved = window.starhomeMergePreviewValues.get(this.dataset.productId);
      this.selects.forEach((select, i) => {
        select.dataset.desired = saved?.options?.[i] || '';
        select.addEventListener('change', () => {
          this.selects.forEach(item => { item.dataset.desired = item.value; });
          this.refresh();
        }, { signal });
      });
      this.inputs.forEach(input => {
        input.value = saved?.fields?.[input.dataset.mergeInput] || '';
        input.addEventListener('input', () => { this.validate(); this.remember(); }, { signal });
      });
      this.querySelector('[data-merge-form]').addEventListener('submit', event => event.preventDefault(), { signal });
      this.refresh();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    refresh() {
      let candidates = this.catalog.variants;
      this.selects.forEach((select, i) => {
        const values = [...new Set(candidates.map(variant => variant.options[i]))];
        const desired = select.dataset.desired;
        select.replaceChildren(...values.map(value => new Option(value, value)));
        select.value = values.includes(desired) ? desired : values[0];
        select.dataset.desired = select.value;
        candidates = candidates.filter(variant => variant.options[i] === select.value);
      });
      this.variant = candidates[0];
      for (const kind of ['width', 'height', 'colour']) {
        const rule = this.variant[kind];
        const input = this.querySelector(`[data-merge-input="${kind}"]`);
        this.querySelector(`[data-merge-field="${kind}"]`).hidden = !rule;
        input.disabled = !rule;
        input.required = !!rule;
        if (Array.isArray(rule)) {
          input.min = rule[0];
          input.max = rule[1];
          this.querySelector(`[data-merge-help="${kind}"]`).textContent = this.rangeMessage(rule);
        } else {
          input.removeAttribute('min');
          input.removeAttribute('max');
        }
      }
      const status = this.variant.source === 'existing' ? this.strings.existing : this.strings.draft;
      this.querySelector('[data-merge-summary]').textContent = `${status} ${this.strings.article} ${this.variant.sku}`;
      this.dataset.selectedSku = this.variant.sku;
      this.dataset.selectedSource = this.variant.source;
      this.validate();
      this.remember();
    }
    rangeMessage(rule) {
      return this.strings.range.replace('__min__', rule[0]).replace('__max__', rule[1]);
    }
    validate() {
      for (const input of this.inputs) {
        const kind = input.dataset.mergeInput;
        const rule = this.variant[kind];
        let message = '';
        if (!input.disabled) {
          const value = input.value.trim();
          if (Array.isArray(rule)) {
            if (!/^\d+$/.test(value) || Number(value) < rule[0] || Number(value) > rule[1]) message = this.rangeMessage(rule);
          } else if (!value) message = this.strings.colourRequired;
        }
        input.setCustomValidity(message);
        input.setAttribute('aria-invalid', String(!!message));
      }
    }
    remember() {
      window.starhomeMergePreviewValues.set(this.dataset.productId, {
        options: this.selects.map(select => select.value),
        fields: Object.fromEntries(this.inputs.map(input => [input.dataset.mergeInput, input.value]))
      });
    }
  });
}
